var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3178 8.59375L11.3278 14.2778C11.3391 14.3447 11.3298 14.4135 11.3009 14.4749C11.2721 14.5364 11.2252 14.5875 11.1665 14.6216C11.1077 14.6557 11.04 14.671 10.9724 14.6656C10.9047 14.6601 10.8403 14.6341 10.7878 14.5911L8.40117 12.7997C8.28595 12.7137 8.14599 12.6672 8.00217 12.6672C7.85835 12.6672 7.71838 12.7137 7.60317 12.7997L5.2125 14.5904C5.16005 14.6334 5.09574 14.6593 5.02816 14.6648C4.96059 14.6702 4.89295 14.655 4.83428 14.621C4.7756 14.587 4.72868 14.536 4.69978 14.4746C4.67088 14.4133 4.66136 14.3446 4.6725 14.2778L5.68183 8.59375",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33398C10.2091 9.33398 12 7.54312 12 5.33398C12 3.12485 10.2091 1.33398 8 1.33398C5.79086 1.33398 4 3.12485 4 5.33398C4 7.54312 5.79086 9.33398 8 9.33398Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIcon);
export default __webpack_public_path__ + "static/media/certificate-icon.f5530aaa7f9aa66c2ff3275bc45414c9.svg";
export { ForwardRef as ReactComponent };